import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TRANSLATIONS } from "./translations";

const LanguageCtx = createContext(null);

export function LanguageProvider({ children }) {
  const { user } = useAuth();
  const [lang, setLang] = useState(() => localStorage.getItem("gt_lang") || "en");

  useEffect(() => {
    if (user && user !== false && user.preferred_language) setLang(user.preferred_language);
  }, [user]);

  const change = async (code) => {
    setLang(code);
    localStorage.setItem("gt_lang", code);
    if (user && user !== false) {
      try { await api.post(`/users/me/language?language=${code}`); } catch (_) {}
    }
  };

  const t = (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key;

  return (
    <LanguageCtx.Provider value={{ lang, change, t }}>
      {children}
    </LanguageCtx.Provider>
  );
}

export const useLanguage = () => useContext(LanguageCtx);
